import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

export const DeleteNonSerializedInventoryItem = ({
  nonSerializedInventoryItem,
  onDelete,
}) => {
  const dispatch = useDispatch()
  let OnDeleteConfirm = function () {
    new rest.SerializableInventoryService(nonSerializedInventoryItem.url)
      .makeDeleteRequest()
      .then((response) => {
        onDelete()
        dispatch(showSuccessToast('Success', 'Non Serialized items  Deleted.'))
      })
      .catch((errors) => {
        console.log(errors)
        dispatch(
          showErrorToast(
            'Error',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  return (
    <>
      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body="Are you sure you want to mark this Non Serializable inventory item?"
        confirmText="Confirm Delete Non Serializable Inventory Item"
        confirmBSStyle="danger"
        title="Deleting Non Serializable Inventory Item"
      >
        <ReactBootstrap.Dropdown.Item variant="dark" eventKey="1">
          {components.ICONS.DELETE} Delete
        </ReactBootstrap.Dropdown.Item>
      </components.Confirm>
    </>
  )
}
